import { profileAPI } from "../api";
import { formatUser } from "../../../entities/auth";

/**
 * 프로필 조회 Use Case
 * API 호출 → 데이터 포맷팅 전체 워크플로우
 */
export class GetProfileUseCase {
  async execute() {
    // API 호출 (순수 HTTP)
    const response = await profileAPI.getProfile();

    // API 응답의 success 필드 확인
    if (!response.success) {
      throw new Error(response.message || "프로필 조회에 실패했습니다.");
    }

    // 사용자 정보 포맷팅
    let formattedUser = null;
    if (response.data?.user) {
      formattedUser = formatUser({
        id: response.data.user.id,
        email: response.data.user.email,
        name: response.data.user.name,
        phone_number: response.data.user.phone_number,
      });
    }

    return {
      user: formattedUser,
    };
  }
}

export const getProfileUseCase = new GetProfileUseCase();
